import Vue from 'vue';

export const EventBus = new Vue();



// WEBPACK FOOTER //
// ./src/components/client/event-bus.js